import { jsx as _jsx } from "react/jsx-runtime";
import { B3_TOKEN } from "../../../anyspend/index.js";
import { base } from "viem/chains";
import { AnySpendCustomExactIn } from "./AnySpendCustomExactIn.js";
export const HYPE_TOKEN_DETAILS = {
    SYMBOL: "HYPE",
    LOGO_URI: "https://cdn.hypeduel.com/hypes-coin.svg",
};
export function AnySpendDepositHype({ loadOrder, mode = "modal", recipientAddress, paymentType = "crypto", sourceTokenAddress, sourceTokenChainId, onSuccess, onOpenCustomModal, mainFooter, onTokenSelect, customUsdInputValues, preferEoa, senderAddress, showFiatOption, slots, content, theme, }) {
    if (!recipientAddress)
        return null;
    const header = () => (_jsx("div", { className: "mb-4 flex flex-col items-center gap-3 text-center", children: _jsx("div", { children: _jsx("h1", { className: "text-as-primary text-xl font-bold", children: paymentType === "crypto" ? "Deposit Crypto" : "Fund with Fiat" }) }) }));
    // Create a modified B3_TOKEN with HYPE branding
    const hypeToken = {
        ...B3_TOKEN,
        symbol: HYPE_TOKEN_DETAILS.SYMBOL,
        metadata: {
            ...B3_TOKEN.metadata,
            logoURI: HYPE_TOKEN_DETAILS.LOGO_URI,
        },
    };
    return (_jsx(AnySpendCustomExactIn, { loadOrder: loadOrder, mode: mode, recipientAddress: recipientAddress, paymentType: paymentType, sourceTokenAddress: sourceTokenAddress, sourceTokenChainId: sourceTokenChainId, destinationToken: hypeToken, destinationChainId: base.id, orderType: "hype_duel", minDestinationAmount: 10, header: header, onSuccess: onSuccess, onOpenCustomModal: onOpenCustomModal, mainFooter: mainFooter, onTokenSelect: onTokenSelect, customUsdInputValues: customUsdInputValues, preferEoa: preferEoa, senderAddress: senderAddress, showFiatOption: showFiatOption, slots: slots, content: content, theme: theme }));
}
